import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "flex confirm-box"
};
const _hoisted_2 = {
  class: "flex-body"
};
const _hoisted_3 = {
  class: "text-center"
};
const _hoisted_4 = {
  class: "footer"
};
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { ElButton } from "element-plus";
import { ref } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'searchCodeByOrderCode',
  emits: ["switchMainProduct"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const codes = ref([""]);
    const models = ref([""]);
    const dialogVisible = ref(false);
    const loadCode = ref("");
    const handleLoadCode = async () => {
      const items = codes.value.map((code, i) => ({
        TypeObject: {
          CodeType: models.value[i],
          ContentStringPublic: code
        }
      }));
      const additionalAttrStore = useAdditionalAttrStore();
      additionalAttrStore.clearCurrentModelCodeObj();
      await additionalAttrStore.setCurrentModelCodeObjs(items);
      emit("switchMainProduct");
      // Your load code logic here
      console.log("Loading code:", loadCode.value);
    };
    const addNewField = appendTo => {
      codes.value.splice(appendTo + 1, 0, "");
    };
    const removeField = idx => {
      if (codes.value.length > 1) {
        codes.value.splice(idx, 1);
      }
    };
    const handleSearch = dialog => {
      dialogVisible.value = dialog;
      // Your search logic here
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_cache[8] || (_cache[8] = _createElementVNode("h4", null, "Aus Bestellcode laden", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", null, " The wika Build ID allows you to conveniently load your configuration. if you have a Build ID, simply enter the code in the following field and click OK. ", -1)), _createVNode(_unref(ElButton), {
        class: "has-text-white",
        onClick: _cache[0] || (_cache[0] = $event => handleSearch(true))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true,
        "z-index": 999999
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("h3", null, "Aus Bestellcode laden", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codes.value, (code, idx) => {
          return _openBlock(), _createElementBlock("div", {
            key: idx,
            class: "code-input-row"
          }, [_createVNode(_component_el_input, {
            modelValue: codes.value[idx],
            "onUpdate:modelValue": $event => codes.value[idx] = $event,
            placeholder: "CodeString",
            onKeyup: _withKeys($event => addNewField(idx), ["enter"]),
            style: {
              "width": "220px",
              "margin-bottom": "8px"
            }
          }, {
            append: _withCtx(() => [codes.value.length > 1 ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "wikaButtonConf has-text-red",
              onClick: $event => removeField(idx)
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
                class: "el-icon-minus"
              }, null, -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup"]), _createVNode(_component_el_input, {
            modelValue: models.value[idx],
            "onUpdate:modelValue": $event => models.value[idx] = $event,
            placeholder: "CodeType",
            maxlength: "10",
            onKeyup: _withKeys($event => addNewField(idx), ["enter"]),
            style: {
              "width": "220px",
              "margin-bottom": "8px",
              "margin-left": "30px"
            }
          }, {
            append: _withCtx(() => [models.value.length > 1 ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "wikaButtonConf has-text-red",
              onClick: $event => removeField(idx)
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("i", {
                class: "el-icon-minus"
              }, null, -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup"])]);
        }), 128)), _createVNode(_unref(ElButton), {
          "data-colour": "blue",
          class: "wikaButtonConf has-text-white",
          onClick: _cache[1] || (_cache[1] = $event => addNewField(codes.value.length - 1))
        }, {
          default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("i", {
            class: "el-icon-plus"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.add")), 1)]),
          _: 1
        })]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElButton), {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: handleLoadCode,
          "data-text": _ctx.$t('button.ok'),
          "data-type": "button"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
          _: 1
        }, 8, ["data-text"])])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});